package ui.styles

import emotion.css.ClassName
import web.cssom.*

object MainElementCardContentStyle {

    val actualId = ClassName(ClassName("card_content_actual_id")){
        position = Position.absolute
        right = 10.px
    }

    val cardMoreButtonForTeachers = ClassName(ClassName("card_more_button_for_teachers")){
        position = Position.absolute
        right = 25.pct
        bottom = 15.pct
    }

    val timeInCard = ClassName(ClassName("time_in_card")){
        display = Display.flex
        alignItems = AlignItems.flexEnd
    }
    val timeInCardFirstComponent = ClassName(ClassName("time_in_card_first_component")){

    }
    val timeInCardSecondComponent = ClassName(ClassName("time_in_card_second_component")){
        opacity = number(0.7)
    }

}